import { Columns } from '@domain-group/suit-theme'

import useSystem from '@hooks/useSystem'

import WebhooksTable from '../WebhooksTable'

import PageLayout from '../../../../components/PageLayout'

const PageContent = (props: { systemId: number }) => {
  const { systemId } = props

  const systemPayload = useSystem({ id: systemId })

  return (
    <PageLayout entityPayload={systemPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <WebhooksTable systemId={systemId} />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
